import styled from 'styled-components';
import { StyledVideoProps } from './Video.types';

export const StyledVideo = styled.div<StyledVideoProps>`
  .video__close-btn {
    background-color: transparent;
    border-style: none;
    padding: 0;
    cursor: pointer;
  }

  ${(props) => props.customStyle}
`;
